import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./AboutTeaser.css";

const AboutTeaser = () => {
  const [ref, isVisible] = useScrollAnimation(0.2);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="about-teaser-section" ref={ref}>
      <div className="about-teaser-container">
        <motion.div
          className="about-teaser-content"
          variants={containerVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          <motion.h2 className="about-teaser-title" variants={itemVariants}>
            The Art of Custom Tailoring
          </motion.h2>

          <motion.p className="about-teaser-text" variants={itemVariants}>
            At PSD Designers, we believe every garment tells a story. For over a
            decade, we've been crafting bespoke pieces that celebrate
            individuality, craftsmanship, and timeless elegance.
          </motion.p>

          <motion.p className="about-teaser-text" variants={itemVariants}>
            Our master tailors combine traditional techniques with contemporary
            design, ensuring each creation is a perfect fusion of artistry and
            precision. From intricate Aari work to stunning bridal couture, we
            transform fabric into wearable masterpieces.
          </motion.p>

          <motion.p className="about-teaser-text" variants={itemVariants}>
            Where stitch meets style—this isn't just our tagline, it's our
            promise to deliver excellence in every thread.
          </motion.p>

          <motion.div variants={itemVariants}>
            <Link to="/about" className="about-teaser-cta">
              <span>Discover Our Story</span>
              <ArrowRight size={20} />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutTeaser;
